<template>
  <div dir="rtl">
    <router-link :to="{ name: 'applicant-history-companies', query: { applicant_id: applicant.resource_id } }" class="m-0 blue_text" target="_blank">
      <b><u>מקומות עבודה אחרונים:</u></b>
    </router-link>
    <p v-if="still_working" @click="editHistoryCompany(last_work_place)" class="blue_text btn">
      <b>(עדיין עובד):</b>
      <br>{{last_work_place.history_company.name}},
      <b>מחלקה: </b> {{last_work_place.department}},
      <b>job_title: </b>{{last_work_place.job_title}}
    </p>
    <div v-else>
      <div v-for="history_company in mutable_history_companies" @click="editHistoryCompany(history_company)" :key="history_company.id" class="blue_text btn">
        <p v-if="history_company.year_end == last_work_place.year_end">
          <b>({{history_company.year_start + '-' + history_company.year_end}}):</b>
          <br>{{history_company.history_company.name}},
          <b>מחלקה: </b> {{history_company.department}},
          <b>job_title: </b>{{history_company.job_title}}
        </p>
      </div>
    </div>
    <p v-if="mutable_history_companies.length == 0">טרם הוזנו מקומות עבודה</p>
    <a @click="createHistoryCompany" class="button is-info">Create History Company</a>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'last-working-places',
  props: {
    applicant: {
      type: Object,
      default: () => {}
    },
    history_companies: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    mutable_history_companies () {
      let cloned_history_companies = [...this.history_companies]
      cloned_history_companies.sort(this.compareHistoryCompanyYearEnd)
      return cloned_history_companies
    },
    last_work_place () {
      if (this.still_working) {
        return this.mutable_history_companies.filter(history_company => history_company.still_working)[0]
      }
      return this.mutable_history_companies[0]
    },
    still_working () {
      return this.mutable_history_companies.filter(history_company => history_company.still_working).length > 0
    }
  },
  methods: {
    compareHistoryCompanyYearEnd (a, b) {
      if (a.year_end > b.year_end) {
        return -1
      }
      return 1
    },
    editHistoryCompany (history_company) {
      this.create({
        designator: 'applicant-history-companies-form-modal',
        component_name: 'ApplicantHistoryCompaniesForm',
        data: history_company,
        applicant_id: this.applicant.resource_id,
        modal_title: history_company.history_company.name
      })
    },
    createHistoryCompany () {
      this.create({
        designator: 'applicant-history-companies-form-modal',
        component_name: 'ApplicantHistoryCompaniesForm',
        is_create: true,
        applicant_id: this.applicant.resource_id,
        modal_title: 'Create new History Company'
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
